export const InsuranceLeadIDsMap = {
    ltdi: [1, 3],
    ci: [2],
    stdi: [4],
    esdi: [99],
    ltc: [98]
}

export enum PRODUCT_IDS {
    ASSURITY_LTDI = 1,
    ASSURITY_CI = 2,
    PRINCIPAL_LTDI = 3 ,
    ASSURITY_STDI = 4,
};